<template>
  <el-dialog
    :style="cssProps"
    :title="title"
    :width="isMobile ? '100%' : width"
    :top="top"
    :visible.sync="synShowDialog"
    :custom-class="customClass"
    :append-to-body="needToBody"
    :close-on-click-modal="closeOnClickModal"
    :close-on-press-escape="false"
    :show-close="showClose"
    :center="isAlignCenter"
    @close="onClose()"
  >
    <div :class="{ 'global-dialog-title': $slots.header }"><slot name="header"></slot></div>
    <slot></slot>
    <div :class="{ 'global-dialog-footer': $slots.footer }"><slot name="footer"></slot></div>
    <slot name="footerExtra"></slot>
  </el-dialog>
</template>

<script>
import isMobileMixins from '@/mixins/isMobile';

export default {
  name: 'vDialog',
  props: {
    show: Boolean,
    // 同el-dialog的top值
    top: { type: String, default: '0' },
    // 模态框距离顶部定位值
    dialogTop: { type: String, default: '50%' },
    // el-dialog的width
    width: { type: String, default: '460px' },
    // 与close 按钮持平的title
    title: { type: String, default: '' },
    needToBody: { type: Boolean, default: false },
    // init el-body 的padding
    bodyPadding: { type: String },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    // 同el-dialog的show-close
    showClose: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: 'vDialog'
    },
    // 同el-dialog的center
    isAlignCenter: {
      type: Boolean,
      default: false
    }
  },
  mixins: [isMobileMixins],
  computed: {
    cssProps() {
      return {
        '--bodyPadding': this.bodyPadding || '12px 40px 40px',
        '--fontSize': this.fontSize || '14px',
        '--topPosition': this.dialogTop || '50%',
        '--transformTop': '-' + this.dialogTop || '-50%'
      };
    },
    synShowDialog: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  methods: {
    onClose() {
      this.$emit('onDialogClose', false);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  top: var(--topPosition);
  transform: translateY(var(--transformTop)) !important;
  .el-dialog__body {
    padding: var(--bodyPadding);
    max-height: 80vh;
    overflow: auto;
  }
  .global-dialog-title {
    color: $title-color;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 32px;
  }
  .global-dialog-footer {
    margin-top: 32px;
  }
}
/deep/ .el-dialog--center {
  .el-dialog__body,
  .global-dialog-title,
  .global-dialog-footer {
    text-align: center;
  }
}
@media (max-width: 550px) {
  /deep/ .el-dialog {
    max-width: 100%;
    top: 199px !important;
    transform: none !important;
  }
}
</style>
